import { FC } from 'react'
import { Form } from 'react-final-form'

import { InfoCardRowForm as InfoCardRowFormComponent, IInfoCardRowFormValues, IInfoCardRowUpsertFormValues } from '../form'

type InfoCardRowFormProps = {
  onSubmit: (values: IInfoCardRowFormValues) => void
  initialValues?: IInfoCardRowUpsertFormValues
  formName: string
  label: string
  options: string[]
}

const InfoCardRowForm: FC<InfoCardRowFormProps> = props => {
  const { onSubmit, initialValues, formName, label, options } = props

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      formName={formName}
      component={InfoCardRowFormComponent}
      label={label}
      options={options}
      keepDirtyOnReinitialize
    />
  )
}

export default InfoCardRowForm